import isEmpty from 'lodash/isEmpty';
import Cookies from 'js-cookie';

// Global utils
import analytics from 'utils/analytics';

// Request utils
import {authCheckRequest, logoutUserRequest} from 'request/auth';

// Redux
import {store} from 'store';
import {clearUserData, setAutoSyncRunning, setConnectedToUser, setDeepSyncRunning, setLastSession, setManualSyncRunning, setQuickSyncRunning, setSession, setSessionWhitelist} from 'store/actions';
import {sendAuthTokenToElectron} from './electron';

class AuthUtil {
	constructor() {
		this.sessionKey = 'SES';
	}
	get sessionStorageKey() {
		return this.sessionKey;
	}
	get sessionToken() {
		return Cookies.get(this.sessionKey);
	}
	async isSessionValid() {
		analytics.setUserProperties();
		if (!isEmpty(this.sessionToken)) {
			const result = await authCheckRequest();
			store.dispatch(setConnectedToUser({connected: result?.data?.isSocketConnected || false}));
			if (!isEmpty(result?.data?.lastSession)) {
				store.dispatch(setSession({session: result?.data?.session} || {}));
				store.dispatch(setLastSession({lastSession: result?.data?.lastSession} || {}));
			}
			store.dispatch(setSessionWhitelist({sessionWhitelist: result?.data?.sessionWhitelist} || false));
			sendAuthTokenToElectron(this.sessionToken);
			if (!isEmpty(result?.data?.runningSync)) {
				const runningSync = result?.data?.runningSync;
				store.dispatch(setAutoSyncRunning({autoSyncRunning: runningSync?.autoSync} || false));
				store.dispatch(setDeepSyncRunning({deepSyncRunning: runningSync?.deepSync} || false));
				store.dispatch(setQuickSyncRunning({quickSyncRunning: runningSync?.quickSync} || false));
				store.dispatch(setManualSyncRunning({manualSyncRunning: runningSync?.manualSync} || false));
			}
			return result;
		} else {
			sendAuthTokenToElectron(false);
			return Promise.reject(new Error('TOKEN_DONT_EXIST'));
		}
	}
	revokeCurrentSession(setState) {
		return new Promise((resolve, reject) => {
			logoutUserRequest(setState)
				.then(resolve)
				.catch(reject)
				.finally(() => {
					Cookies.remove(this.sessionKey);
					store.dispatch(clearUserData());
				});
		});
	}
	async setNewSession(token) {
		return await Cookies.set(this.sessionKey, token, {
			expires: 30,
		});
	}
}

export default new AuthUtil();
